import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/(auth)/admin/(organisations)/organisation/',
)({
    beforeLoad: async ({ search }) => {
        const { organisationId } = search;

        throw redirect({
            to: '/admin/organisation/information',
            search: { organisationId },
        });
    },
});
